export enum Ach {
  GET_TRANSACTIONS_REQUEST = '@ach/GET_TRANSACTIONS_REQUEST',
  GET_TRANSACTIONS_SUCCESS = '@ach/GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_FAILURE = '@ach/GET_TRANSACTIONS_FAILURE',
}
